var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"display-4"},[_vm._v("Resources")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }